import { render, staticRenderFns } from "./personalInfo.vue?vue&type=template&id=dc018028&scoped=true"
import script from "./personalInfo.vue?vue&type=script&lang=js"
export * from "./personalInfo.vue?vue&type=script&lang=js"
import style0 from "./personalInfo.vue?vue&type=style&index=0&id=dc018028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc018028",
  null
  
)

export default component.exports